export const infoCircledInvert =
  'M55.78,42.2C8.29,82.04,2.31,152.66,42.21,200.39c39.9,47.34,110.93,53.26,158.02,13.41c47.48-39.84,53.47-110.46,13.57-158.19C173.89,8.27,103.26,2.36,55.78,42.2z M141.97,192.5h-27.53v-87.97h27.53V192.5zM141.97,90.72h-27.53V63.11h27.53V90.72z'
